// Örnek servis codiagno login
import axios from '../javascript/custom-axios';
const RESOURCE_NAME = '/courierInformation';

export default {
  addCarrier(body) {
    return axios.post(`${RESOURCE_NAME}/add`, body);
  },
  editCarrier(body) {
    return axios.put(`${RESOURCE_NAME}/update`, body);
  },

  /**
   * Update a carrier for supplier.
   * @param {{ Id: string, EstimatedCourierDateStart: string, EstimatedCourierDateEnd: "string", CarrierName: string, CarrierPhone: string, CarrierNumberPlate: string }} body 
   * @returns {Promise}
   */
  updateCarrierForSupplier(body) {
    return axios.put(`${RESOURCE_NAME}/updateForCarrier`, body);
  },
};
